<template>
  <div class="card card-custom card-stretch gutter-b">
    <div class="card-body d-flex flex-column">
      <div class="flex-grow-1 pb-5">
        <h1 style="text-transform: uppercase">
          {{ $t("OVERVIEW.PAGETITLE") }}
        </h1>
        <div class="d-flex align-items-center mb-6">
          <span class="text-muted font-weight-bold font-size-lg flex-grow-1">
            {{ $t("OVERVIEW.Description") }}
          </span>
        </div>
        <div class="vld-parent">
          <loading
            :active.sync="isLoading"
            :can-cancel="true"
            :is-full-page="true"
          ></loading>
        </div>

        <v-app>
          <v-container>
            <v-row v-if="isAdmin" style="margin-top: 25px;">
              <v-col cols="12" class="d-flex justify-end text-center">
                <v-btn
                  class="primary custom_button"
                  large
                  height="50"
                  style="margin-right: 15px;"
                  @click="toInvoice(document_type_id.DOCUMENT_INVOICE)"
                >
                  <v-icon left>mdi-plus</v-icon>
                  {{ $t("OVERVIEW.Button_NewInvoice") }}
                </v-btn>
                <v-btn
                  class="primary custom_button"
                  large
                  height="50"
                  @click="toInvoice(document_type_id.DOCUMENT_CREDIT)"
                >
                  <v-icon left>mdi-plus</v-icon>
                  {{ $t("OVERVIEW.Button_CreditNote") }}
                </v-btn>
              </v-col>
            </v-row>
            <v-row style="margin-top: 25px;">
              <v-col
                :cols="isAdmin ? 12 : 12"
                :md="isAdmin ? 5 : 6"
                :lg="isAdmin ? 4 : 4"
              >
                <v-autocomplete
                  v-if="isAdmin"
                  attach
                  v-model="selectedClient"
                  :items="company_clients"
                  item-text="CompanyName"
                  return-object
                  label="Bitte Kunden auswählen (Filter nach Kunde)"
                  filled
                  dense
                  clearable
                  hide-details="auto"
                ></v-autocomplete>
              </v-col>
            </v-row>

            <v-row style="margin-top: 10px;">
              <v-col cols="12" md="4" lg="4">
                <v-text-field
                  v-model="draftFilters.search"
                  filled
                  dense
                  clearable
                  label="Suche nach Rechnungsnummer"
                  prepend-inner-icon="mdi-magnify"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2">
                <v-select
                  v-model="draftFilters.status"
                  :items="statusOptions"
                  item-text="text"
                  item-value="value"
                  filled
                  dense
                  clearable
                  label="Status"
                  hide-details="auto"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="2" lg="2">
                <v-select
                  v-model="draftFilters.is_paid"
                  :items="paidOptions"
                  item-text="text"
                  item-value="value"
                  filled
                  dense
                  clearable
                  label="Bezahlt"
                  hide-details="auto"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2">
                <v-text-field
                  v-model="draftFilters.from_date"
                  type="date"
                  filled
                  dense
                  label="Von"
                  :error="hasInvalidDateRange"
                  :error-messages="
                    hasInvalidDateRange
                      ? ['Von-Datum darf nicht nach Bis liegen']
                      : []
                  "
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col cols="12" sm="6" md="3" lg="2">
                <v-text-field
                  v-model="draftFilters.to_date"
                  type="date"
                  filled
                  dense
                  label="Bis"
                  :error="hasInvalidDateRange"
                  hide-details="auto"
                ></v-text-field>
              </v-col>
              <v-col
                cols="12"
                md="12"
                lg="12"
                class="d-flex justify-space-between align-center flex-wrap"
              >
                <div
                  class="text-muted font-weight-bold font-size-sm mb-2 mb-md-0"
                >
                  {{ resultSummary }}
                </div>
                <div class="d-flex align-center flex-wrap">
                  <div
                    v-if="activeFilterChips.length"
                    class="d-flex align-center flex-wrap mr-4"
                  >
                    <v-chip
                      v-for="chip in activeFilterChips"
                      :key="chip.key"
                      small
                      outlined
                      color="primary"
                      class="mr-2 mb-2"
                    >
                      {{ chip.label }}
                    </v-chip>
                  </div>
                  <v-btn
                    text
                    color="primary"
                    :disabled="!hasActiveFilters"
                    class="mr-2 mb-2"
                    @click="resetFilters"
                  >
                    <v-icon left small>mdi-filter-remove-outline</v-icon>
                    Filter zurücksetzen
                  </v-btn>
                  <v-btn
                    outlined
                    color="primary"
                    class="mb-2"
                    @click="queueRefresh({ immediate: true, force: true })"
                  >
                    <v-icon left small>mdi-refresh</v-icon>
                    Aktualisieren
                  </v-btn>
                </div>
              </v-col>
            </v-row>
            <v-row class="mt-4">
              <v-col cols="12">
                <v-data-table
                  :headers="headers"
                  :items="documents"
                  :options.sync="options"
                  :server-items-length="totalDocuments"
                  :footer-props="footerProps"
                  class="table1"
                  :loading="loadingvariable"
                  loading-text="Bitte warten... Dokumente werden geladen"
                >
                  <template v-slot:footer.page-text="items">
                    {{ items.pageStart }} - {{ items.pageStop }} von
                    {{ items.itemsLength }}
                  </template>
                  <template v-slot:item.documents_type_id="{ item }">
                    <v-chip
                      small
                      :color="getDocumentTypeColor(item.documents_type_id)"
                      text-color="white"
                      class="font-weight-bold"
                    >
                      {{ getDocumentType(item.documents_type_id) }}
                    </v-chip>
                  </template>
                  <template v-slot:item.invoice_number="{ item }">
                    <div class="font-weight-bold">
                      {{ item.invoice_number }}
                    </div>
                    <div
                      v-if="item.reference_number"
                      class="text-muted font-size-xs"
                    >
                      Ref: {{ item.reference_number }}
                    </div>
                  </template>
                  <template v-slot:item.invoice_date="{ item }">
                    {{ formatDate(item.invoice_date) }}
                  </template>
                  <template v-slot:item.client="{ item }">
                    {{ item.client ? item.client.CompanyName : "-" }}
                  </template>
                  <template v-slot:item.status="{ item }">
                    <v-chip
                      small
                      outlined
                      :color="getStatusColor(item.status)"
                      class="font-weight-medium"
                    >
                      {{ $t("OVERVIEW." + item.status) }}
                    </v-chip>
                  </template>
                  <template v-slot:item.is_paid="{ item }">
                    <v-chip
                      small
                      :color="getPaidChipColor(item)"
                      :outlined="!item.is_paid"
                      :disabled="item.documents_type_id === 3"
                      class="overview-paid-chip"
                    >
                      {{ getPaidLabel(item) }}
                    </v-chip>
                  </template>
                  <template v-slot:item.auto_generated="{ item }">
                    <v-tooltip
                      v-if="item.auto_generated === 1"
                      top
                      attach=""
                      dense
                      color="primary"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon small color="green" v-bind="attrs" v-on="on">
                          mdi-check
                        </v-icon>
                      </template>
                      <span>Diese Rechnung wurde generiert</span>
                    </v-tooltip>
                    <span v-else class="text-muted">-</span>
                  </template>
                  <template v-slot:item.user="{ item }">
                    {{ item.user ? item.user.lastname : "-" }}
                  </template>
                  <template v-slot:item.actions="{ item }">
                    <div class="d-flex justify-center">
                      <v-tooltip
                        v-if="isAdmin"
                        top
                        attach=""
                        dense
                        color="primary"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            small
                            class="mr-2"
                            @click="toInvoiceWithHash(item)"
                            style="font-size: 20px;"
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-magnify
                          </v-icon>
                        </template>
                        <span>Öffne Dokument</span>
                      </v-tooltip>
                      <v-tooltip
                        v-if="isAdmin"
                        top
                        attach=""
                        dense
                        color="primary"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-if="
                              item.status === document_status_types.STATUS_DRAFT
                            "
                            small
                            :disabled="item.edited !== 0"
                            class="mr-2"
                            @click="deleteDocument(item)"
                            style="font-size: 20px;"
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                        <span>Lösche Dokument</span>
                      </v-tooltip>
                      <v-tooltip top attach="" dense color="primary">
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-if="
                              item.status !== document_status_types.STATUS_DRAFT
                            "
                            small
                            class="mr-2"
                            @click="getPdf(item)"
                            style="font-size: 18px;"
                            color="brown"
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-file-pdf
                          </v-icon>
                        </template>
                        <span>PDF Download</span>
                      </v-tooltip>
                      <v-tooltip
                        v-if="isAdmin"
                        top
                        attach=""
                        dense
                        color="primary"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-if="
                              item.status !==
                                document_status_types.STATUS_DRAFT &&
                                !item.reference_number
                            "
                            small
                            class="mr-2"
                            @click="createCancellation(item.unique_hash)"
                            style="font-size: 18px;"
                            v-bind="attrs"
                            v-on="on"
                          >
                            mdi-file-document-box-remove
                          </v-icon>
                        </template>
                        <span>Rechnung stornieren</span>
                      </v-tooltip>
                    </div>
                  </template>
                  <template v-slot:no-data>
                    <div class="overview-empty-state">
                      <div class="overview-empty-state__title">
                        Keine Dokumente gefunden
                      </div>
                      <div class="overview-empty-state__text">
                        Keine passenden Rechnungen gefunden.
                      </div>
                      <v-btn
                        v-if="hasActiveFilters"
                        text
                        color="primary"
                        @click="resetFilters"
                      >
                        Filter zurücksetzen
                      </v-btn>
                    </div>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-container>
        </v-app>
      </div>
    </div>
  </div>
</template>

<style>
.v-data-footer__select {
  display: none !important;
}

.custom_button.theme--light.v-btn.v-btn--disabled {
  background-color: lightgray !important;
}

.overview-paid-chip {
  min-width: 72px;
  justify-content: center;
}

.overview-empty-state {
  padding: 32px 16px;
  text-align: center;
}

.overview-empty-state__title {
  color: #1f2a37;
  font-size: 16px;
  font-weight: 700;
}

.overview-empty-state__text {
  color: #6b7280;
  margin-top: 8px;
}

@media (max-width: 959px) {
}
</style>

<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import ApiService from "@/core/services/api.service";
import { LOGOUT, getUserProfile } from "@/core/services/store/auth.module";
import DocumentType from "@/stub/doctype";
import DocumentStatusTypes from "@/stub/statustypes";
import Swal from "sweetalert2";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import VTooltip from "v-tooltip";
import Vue from "vue";

Vue.use(VTooltip);

const DEFAULT_FILTERS = () => ({
  search: "",
  status: null,
  is_paid: null,
  from_date: null,
  to_date: null
});

export default {
  name: "overview",
  components: { Loading },
  data: function() {
    return {
      selectedCompany: null,
      selectedClient: null,
      company_clients: [],
      currentUser: null,
      loadingvariable: false,
      isLoading: false,
      hasInitialized: false,
      suppressFilterWatch: false,
      filterDebounce: null,
      latestRequestId: 0,
      headers: [
        {
          text: this.$t("OVERVIEW.Type"),
          value: "documents_type_id",
          align: "center",
          sortable: false
        },
        {
          text: this.$t("OVERVIEW.Number"),
          value: "invoice_number",
          align: "center",
          sortable: false
        },
        {
          text: this.$t("OVERVIEW.Date"),
          value: "invoice_date",
          align: "center",
          sortable: false
        },
        {
          text: this.$t("OVERVIEW.Client"),
          value: "client",
          sortable: false
        },
        {
          text: this.$t("OVERVIEW.Status"),
          value: "status",
          align: "center",
          sortable: false
        },
        {
          text: this.$t("OVERVIEW.Paid"),
          value: "is_paid",
          align: "center",
          sortable: false
        },
        {
          text: this.$t("OVERVIEW.AUTO_GENERATED"),
          value: "auto_generated",
          align: "center",
          sortable: false
        },
        {
          text: "Ersteller/in",
          value: "user",
          align: "center",
          sortable: false
        },
        {
          text: this.$t("OVERVIEW.Options"),
          value: "actions",
          sortable: false,
          align: "center"
        }
      ],
      documents: [],
      totalDocuments: 0,
      options: {
        page: 1,
        itemsPerPage: 50
      },
      pagination: {
        current_page: 1,
        last_page: 1,
        per_page: 50,
        total: 0,
        from: 0,
        to: 0,
        has_more_pages: false
      },
      draftFilters: DEFAULT_FILTERS(),
      requestFilters: DEFAULT_FILTERS(),
      document_type_id: {
        ...DocumentType
      },
      document_status_types: {
        ...DocumentStatusTypes
      }
    };
  },
  computed: {
    isAdmin() {
      return !!(this.currentUser && this.currentUser.admin === 1);
    },
    hasInvalidDateRange() {
      if (!this.draftFilters.from_date || !this.draftFilters.to_date) {
        return false;
      }

      return this.draftFilters.from_date > this.draftFilters.to_date;
    },
    hasActiveFilters() {
      return (
        !!this.selectedClient ||
        !!this.requestFilters.search ||
        !!this.requestFilters.status ||
        this.requestFilters.is_paid !== null ||
        !!this.requestFilters.from_date ||
        !!this.requestFilters.to_date
      );
    },
    activeFilterChips() {
      const chips = [];

      if (this.selectedClient) {
        chips.push({
          key: "client",
          label: `Kunde: ${this.selectedClient.CompanyName}`
        });
      }
      if (this.requestFilters.search) {
        chips.push({
          key: "search",
          label: `Rechnungsnummer: ${this.requestFilters.search}`
        });
      }
      if (this.requestFilters.status) {
        chips.push({
          key: "status",
          label: `Status: ${this.$t("OVERVIEW." + this.requestFilters.status)}`
        });
      }
      if (this.requestFilters.is_paid !== null) {
        chips.push({
          key: "is_paid",
          label: this.requestFilters.is_paid === 1 ? "Bezahlt" : "Offen"
        });
      }
      if (this.requestFilters.from_date) {
        chips.push({
          key: "from_date",
          label: `Von: ${this.formatDate(this.requestFilters.from_date)}`
        });
      }
      if (this.requestFilters.to_date) {
        chips.push({
          key: "to_date",
          label: `Bis: ${this.formatDate(this.requestFilters.to_date)}`
        });
      }

      return chips;
    },
    resultSummary() {
      if (this.loadingvariable && !this.documents.length) {
        return "Dokumente werden geladen...";
      }

      if (!this.totalDocuments) {
        return this.hasActiveFilters
          ? "Keine Treffer für die aktuellen Filter"
          : "Noch keine Dokumente vorhanden";
      }

      return `${this.pagination.from || 0} - ${this.pagination.to || 0} von ${
        this.totalDocuments
      } Dokumenten`;
    },
    statusOptions() {
      return [
        { text: "Entwurf", value: this.document_status_types.STATUS_DRAFT },
        { text: "Gespeichert", value: this.document_status_types.STATUS_SAVED },
        { text: "Gesendet", value: this.document_status_types.STATUS_SENT }
      ];
    },
    paidOptions() {
      return [
        { text: "Offen", value: 0 },
        { text: "Bezahlt", value: 1 }
      ];
    },
    footerProps() {
      return {
        "items-per-page-options": [25, 50, 100]
      };
    }
  },
  created() {
    this.initializePage();
  },
  beforeDestroy() {
    if (this.filterDebounce) {
      clearTimeout(this.filterDebounce);
    }
  },
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "Overview" }]);

    const userProfile = getUserProfile();
    this.currentUser = userProfile ? JSON.parse(userProfile) : null;
  },
  watch: {
    options: {
      handler(newOptions, oldOptions) {
        if (!this.hasInitialized) {
          return;
        }

        if (
          !oldOptions ||
          newOptions.page !== oldOptions.page ||
          newOptions.itemsPerPage !== oldOptions.itemsPerPage
        ) {
          this.fetchInvoices();
        }
      },
      deep: true
    },
    selectedClient() {
      if (this.suppressFilterWatch || !this.hasInitialized) {
        return;
      }

      this.queueRefresh({ immediate: true });
    },
    draftFilters: {
      handler() {
        if (this.suppressFilterWatch || !this.hasInitialized) {
          return;
        }

        this.queueRefresh();
      },
      deep: true
    }
  },
  methods: {
    async initializePage() {
      this.loadingvariable = true;

      try {
        const [companiesResponse, clientsResponse] = await Promise.all([
          ApiService.query("/companies"),
          ApiService.query("/clients/all")
        ]);

        this.selectedCompany = companiesResponse.data.companies[0] || null;
        this.company_clients = clientsResponse.data.clients || [];
        this.hasInitialized = true;
        await this.fetchInvoices();
      } catch (error) {
        this.handleApiError(error);
      } finally {
        this.loadingvariable = false;
      }
    },
    queueRefresh({ immediate = false, force = false } = {}) {
      if (this.filterDebounce) {
        clearTimeout(this.filterDebounce);
      }

      if (immediate) {
        this.applyFilters({ force });
        return;
      }

      this.filterDebounce = setTimeout(() => {
        this.applyFilters({ force });
      }, 350);
    },
    applyFilters({ force = false } = {}) {
      if (this.hasInvalidDateRange) {
        return;
      }

      const nextFilters = this.normalizeFilters(this.draftFilters);
      const filtersChanged =
        JSON.stringify(nextFilters) !== JSON.stringify(this.requestFilters);

      this.requestFilters = nextFilters;

      if ((filtersChanged || force) && this.options.page !== 1) {
        this.options = {
          ...this.options,
          page: 1
        };
        return;
      }

      if (filtersChanged || force) {
        this.fetchInvoices();
      }
    },
    normalizeFilters(filters) {
      const search = filters.search ? filters.search.trim() : "";

      return {
        search: search || "",
        status: filters.status || null,
        is_paid:
          filters.is_paid === 0 || filters.is_paid === 1
            ? filters.is_paid
            : null,
        from_date: filters.from_date || null,
        to_date: filters.to_date || null
      };
    },
    resetFilters() {
      this.suppressFilterWatch = true;
      this.selectedClient = null;
      this.draftFilters = DEFAULT_FILTERS();
      this.requestFilters = DEFAULT_FILTERS();

      if (this.filterDebounce) {
        clearTimeout(this.filterDebounce);
      }

      this.$nextTick(() => {
        this.suppressFilterWatch = false;
        this.queueRefresh({ immediate: true, force: true });
      });
    },
    buildOverviewRequest() {
      const resource = this.selectedClient
        ? `/overview/filtered/${this.selectedClient.id}`
        : "/overview";
      const params = {
        page: this.options.page,
        per_page: this.options.itemsPerPage
      };

      if (this.requestFilters.search) {
        params.search = this.requestFilters.search;
      }
      if (this.requestFilters.status) {
        params.status = this.requestFilters.status;
      }
      if (this.requestFilters.is_paid !== null) {
        params.is_paid = this.requestFilters.is_paid;
      }
      if (this.requestFilters.from_date) {
        params.from_date = this.requestFilters.from_date;
      }
      if (this.requestFilters.to_date) {
        params.to_date = this.requestFilters.to_date;
      }

      return {
        resource,
        config: {
          params
        }
      };
    },
    async fetchInvoices() {
      const requestId = ++this.latestRequestId;
      this.loadingvariable = true;
      const { resource, config } = this.buildOverviewRequest();

      try {
        const { data } = await ApiService.query(resource, config);
        if (requestId !== this.latestRequestId) {
          return;
        }

        this.applyOverviewResponse(data);
      } catch (error) {
        if (requestId !== this.latestRequestId) {
          return;
        }

        this.handleApiError(error);
      } finally {
        if (requestId === this.latestRequestId) {
          this.loadingvariable = false;
        }
      }
    },
    applyOverviewResponse(data) {
      this.documents = data.invoices || [];
      this.totalDocuments =
        data.invoiceTotalCount ||
        (data.pagination ? data.pagination.total : this.documents.length);
      this.pagination = {
        current_page: data.pagination ? data.pagination.current_page : 1,
        last_page: data.pagination ? data.pagination.last_page : 1,
        per_page: data.pagination
          ? data.pagination.per_page
          : this.options.itemsPerPage,
        total: data.pagination ? data.pagination.total : this.totalDocuments,
        from: data.pagination ? data.pagination.from : 0,
        to: data.pagination ? data.pagination.to : this.documents.length,
        has_more_pages: data.pagination ? data.pagination.has_more_pages : false
      };

      if (this.options.itemsPerPage !== this.pagination.per_page) {
        this.options = {
          ...this.options,
          itemsPerPage: this.pagination.per_page
        };
      }
    },
    handleApiError(error) {
      const response = error && error.response ? error.response : null;

      if (response && response.status === 401) {
        this.$store
          .dispatch(LOGOUT)
          .then(() => this.$router.push({ name: "login" }));
        return;
      }

      if (response && response.data && response.data.message) {
        Swal.fire("Fehler", response.data.message, "error");
      }
    },
    fetchInvoicesAfterDelete() {
      const isOnlyItemOnPage =
        this.documents.length === 1 && this.options.page > 1;

      if (isOnlyItemOnPage) {
        this.options = {
          ...this.options,
          page: this.options.page - 1
        };
        return;
      }

      this.fetchInvoices();
    },
    getDocumentType(documents_type_id) {
      switch (documents_type_id) {
        case 1:
          return "RECHNUNG";
        case 2:
          return "GUTSCHRIFT";
        case 3:
          return "STORNIERUNG";
        default:
          return "-";
      }
    },
    getDocumentTypeColor(documents_type_id) {
      switch (documents_type_id) {
        case 1:
          return "primary";
        case 2:
          return "teal";
        case 3:
          return "red";
        default:
          return "grey";
      }
    },
    getStatusColor(status) {
      switch (status) {
        case this.document_status_types.STATUS_DRAFT:
          return "grey";
        case this.document_status_types.STATUS_SAVED:
          return "orange";
        case this.document_status_types.STATUS_SENT:
          return "green";
        default:
          return "primary";
      }
    },
    getPaidChipColor(item) {
      if (item.documents_type_id === 3) {
        return "grey lighten-2";
      }

      return item.is_paid ? "green lighten-2" : "grey lighten-2";
    },
    getPaidLabel(item) {
      if (item.documents_type_id === 3) {
        return "-";
      }

      return item.is_paid ? "Bezahlt" : "Offen";
    },
    formatDate(value) {
      if (!value) {
        return "-";
      }

      return new Date(value).toLocaleDateString("de-DE", {
        day: "2-digit",
        month: "2-digit",
        year: "numeric"
      });
    },
    createCancellation(unique_hash) {
      Swal.fire({
        title: "Stornierung erstellen",
        text: "Möchten Sie diese Rechnung wirklich stornieren?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Ja",
        cancelButtonText: "Abbrechen"
      }).then(invoice => {
        if (invoice.value) {
          this.isLoading = true;
          ApiService.post("invoice/cancellation", {
            unique_hash: unique_hash
          })
            .then(() => {
              location.reload();
            })
            .catch(error => {
              const response = error && error.response ? error.response : null;

              if (response && response.status === 401) {
                this.$store
                  .dispatch(LOGOUT)
                  .then(() => this.$router.push({ name: "login" }));
              } else {
                Swal.fire({
                  title: `${
                    response ? response.status : ""
                  } Fehler bei der Stornierung`,
                  text:
                    response && response.data && response.data.message
                      ? response.data.message
                      : "Die Stornierung konnte nicht erstellt werden.",
                  icon: "error",
                  confirmButtonText: "Ok"
                });
              }
              this.isLoading = false;
            });
        }
      });
    },
    getPdf(item) {
      this.isLoading = true;
      ApiService.getFile("/invoice/pdf", item.unique_hash)
        .then(response => {
          this.isLoading = false;
          const blobUrl = window.URL.createObjectURL(
            new Blob([response.data], { type: "application/pdf" })
          );
          const link = document.createElement("a");
          link.href = blobUrl;
          link.setAttribute("download", item.invoice_number);
          link.click();
          link.remove();
          URL.revokeObjectURL(blobUrl);
        })
        .catch(error => {
          this.isLoading = false;
          this.handleApiError(error);
        });
    },
    toInvoice(document_type_id) {
      this.$router.push({
        name: "invoice",
        query: { type: document_type_id },
        params: { company: this.selectedCompany },
        pathToRegexpOptions: { strict: true }
      });
    },
    deleteDocument(item) {
      Swal.fire({
        title: "Dokument löschen",
        text: "Möchten Sie dieses Dokument wirklich löschen?",
        icon: "warning",
        timerProgressBar: true,
        showCancelButton: true,
        confirmButtonColor: "#dc3545",
        confirmButtonText: "Löschen",
        cancelButtonText: "Abbrechen"
      }).then(result => {
        if (result.value) {
          this.isLoading = true;
          ApiService.post("/invoice/delete/" + item.unique_hash)
            .then(({ data }) => {
              this.isLoading = false;
              Swal.fire("", data.message, "success");
              this.fetchInvoicesAfterDelete();
            })
            .catch(error => {
              const response = error && error.response ? error.response : null;

              if (response && response.status === 403) {
                Swal.fire("", response.data.message, "error");
              } else {
                this.handleApiError(error);
              }

              this.isLoading = false;
            });
        }
      });
    },
    toInvoiceWithHash(item) {
      this.$router.push({
        name: item.unique_hash ? "invoice-hash" : "invoice",
        params: { hash: item.unique_hash },
        pathToRegexpOptions: { strict: true }
      });
    }
  }
};
</script>
